import { useSelector } from 'react-redux';
import Typography from '../components/Typography';
import Button from '../components/Button';
import { makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles({
  description: {
    fontSize: '16px',
    margin: '16px 8px',
    textAlign: 'left',
    lineHeight: '1.5'
  },
  price: {
    fontSize: '42px',
    fontWeight: '600',
    textAlign: 'center',
    margin: '30px 0 40px'
  },
  button: {
    margin: '10px 0 25px',
    width: '100%',
    height: '56px',
    border: '0'
  }
});

export const DetailsStep = () => {
  const classes = useStyles();
  const history = useHistory();
  const { cover, galeno } = useSelector((state) => state.quote);
  const { car, person } = useSelector((state) => state);

  const filteredDetailCover = (detailsCover) => detailsCover.filter((item) => item !== '');

  return (
    <>
      <Typography text={cover.descripcionCobertura} />
      <Typography text={`$ ${Math.round(cover.premio)}`} variant='h2' className={classes.price} />

      {filteredDetailCover(cover.listaAdicionales).map((item, index) => (
        <Typography key={index} text={item} variant='h2' className={classes.description} />
      ))}

      <Button
        text='Lo quiero!'
        color='secondary'
        href={`https://api.whatsapp.com/send?phone=5492613281511&text=*DETALLE%20DE%20COTIZACION%20NRO%20${
          galeno.solicitud
        }*%0A%0A*CLIENTE*%0A*Nombre:*%20${person.name}%0A*Edad:*%20${
          person.age
        }%0A%0A*VEHICULO*%0A*Marca:*%20${car.brand}%0A*Modelo:*%20${car.version}%0A*Año:*%20${
          car.year
        }%0A%0A*SEGURO*%0A*Aseguradora:*%20GALENO%0A*Cobertura:*%20${
          cover.descripcionCobertura
        }%0A*Precio:*%20$${Math.round(cover.premio)}`}
        target={'_blank'}
      />
      <Button
        text='Volver'
        variant='outlined'
        color='inherit'
        className={classes.button}
        onClick={() => history.goBack()}
      />
    </>
  );
};
